import { put, takeEvery, select } from 'redux-saga/effects'
import { Api, Game } from '../../Core'

import * as actions from './settings.actions'
import * as savePointActions from '../SavePoint/savePoint.actions'
import * as savePointSelectors from '../SavePoint/savePoint.selectors'
import * as settingsSelectors from './settings.selectors'

import HelpButton from './HelpButton'
import SettingsMenuButton from './SettingsMenuButton'
import SettingsMenuPopup from './SettingsMenuPopup'

/**
 *  Init module.
 */
function* init() {
  yield loadComponents()
}

/**
  Load Components
 */
export function* loadComponents() {
  const components = {
    HelpButton,
    SettingsMenuButton,
    SettingsMenuPopup,
  }

  yield put(Game.actions.registerComponents(components))
}

/**
 * Load languages from server
 */
export function* loadLanguages() {
  try {
    let receivedLanguages = yield Api.get('/games-core/languages', {})
    yield put(actions.setLanguages(receivedLanguages))
  } catch (e) {
    if (e && e.status === 401 && location.pathname.indexOf('tutorial') != 1) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

/**
  Sync settings with savePoint
 */
export function* savePointSync() {
  const settings = yield select(settingsSelectors.getSettings)
  yield put(savePointActions.syncWithSettings(settings))
}

/**
 *  Sync settings from savePoint
 */
export function* settingsSyncFromSP() {
  const settings = yield select(savePointSelectors.getSettings)

  // yield put(i18n.actions.syncI18n(settings))
  yield put(actions.syncFromSavePoint(settings))
}

/***/
export function* selectLanguageOnLMS(action) {
  let locale = action.data
  yield Api.put('/games-core/languages', {}, { locale })
  //TODO: hacer que el i18n mire el liceseData, y qu este se actualice, v2, de momento reload
  window.location.reload()
}
/***/
export function* onFirstClick(action) {
  const soundBackground = yield select(settingsSelectors.getSoundBackground)

  yield put(actions.setSoundBackground(action.data ? !soundBackground : soundBackground))
}
/**
 *  Settings sagas entrypoint
 */
export function* sagas() {
  yield init()
  yield takeEvery(
    [
      actions.SET_SOUND_BACKGROUND,
      actions.SET_SOUND_EFFECTS,
      actions.SET_SOUND_MUSIC,
      actions.TOGGLE_SHADOWS,
    ],
    savePointSync
  )
  yield takeEvery(actions.SELECT_LANGUAGE, selectLanguageOnLMS)
  yield takeEvery(savePointActions.LOADED, settingsSyncFromSP)
  yield takeEvery(Game.actions.INIT, loadLanguages)
  yield takeEvery(Game.actions.FIRST_CLICK, onFirstClick)
}
